import { chatsActions } from "../../actionTypes";

const initialState = {
	token: {},
	fetching: false,
	fetched: false,
	error: null,
};

const Reducer = (state = initialState, action) => {
	switch (action.type) {
		case chatsActions.STORE_TOKEN: {
			return { ...initialState, fetching: true };
		}

		case chatsActions.STORE_TOKEN_FULFILLED: {
			return {
				...state,
				fetching: false,
				fetched: true,
				token: action.payload,
			};
		}

		case chatsActions.STORE_TOKEN_REJECTED: {
			return { ...state, fetching: false, error: action.payload };
		}

		default:
	}

	return state;
};

export default Reducer;
